/**
 * A dataservice that provides CRUD operations on the file upload service
 */
export class FileUploadService {
  public static $inject = ['$resource', 'Upload', '$q', '$rootScope'];
  private uploadService: any;
  private maxFileSize = 100000000;

  constructor(
    private $resource: ng.resource.IResourceService,
    private Upload,
    private $q: ng.IQService,
    private $rootScope: ng.IRootScopeService) { }

  /**
   * Function to check the file size
   *
   * @param file The file to check
   * @returns The promise of the file size
   */
  public checkFileSize = (file: any) => {
    const deferred = this.$q.defer();

    if (file.size > this.maxFileSize) {
      deferred.reject(`${this.maxFileSize / 1000000}`);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  }

  /**
   * Function to upload a file to the file uploads service
   *
   * @param file The file to upload
   * @returns The promise of the original server interaction and then the location id of the created resource
   */
  public uploadFile(file: any) {
    const deferred = this.$q.defer();

    this.uploadService = this.Upload.upload({
      url: 'api/file-uploads',
      data: { file: file }
    });

    this.uploadService.then((response) => {
      return deferred.resolve((<any>response).headers().location);
    }, (response) => {
      return deferred.reject(response);
    }, (evt) => {
      this.$rootScope.$broadcast('upload-progress', {
        uploadProgress: (<any>parseInt)(100.0 * evt.loaded / evt.total)
      });
    });

    return deferred.promise;
  }

  /**
   * Function to cancel a file upload
   */
  public abortUpload() {
    this.uploadService.abort();
  }
}
